export const FORGET_USER = 'forgot_user';
export const FORGET_USER_SUCCESSFUL = 'forget_user_successfull';
export const FORGET_PASSWORD_API_FAILED = 'FORGET_PASSWORD_API_FAILED';

export const RESET_USER_PASSWORD = 'reset_user_password';
export const RESET_PASSWORD_USER_SUCCESSFUL = 'reset_user_password_successful';
export const RESET_PASSWORD_USER_ERROR = 'reset_user_password_error';
